<template>
    <div
        class="b-table-sticky-header table-responsive mt-1 m-0"
        style="max-height:281px;"
    >
        <b-table-simple
            class="mt-0 mb-0"
            no-border-collapse
            small
        >
            <b-thead>
                <b-tr>
                    <b-th
                        class="text-center text-nowrap px-0"
                        style="z-index:3"
                    >
                        Date
                    </b-th>
                    <b-th
                        v-for="(product, productIdx) in tableData.allProducts" :key="productIdx"
                        class="text-right text-nowrap"
                        :style="{'padding-right': tableData.allProducts.length < 4 ? '30px' : ''}"
                        style="width:100px;"
                    >
                        {{ product.replace('AWS', '').replace('Amazon', '') }}
                    </b-th>
                </b-tr>
            </b-thead>
            <b-tbody class="table-sm">
                <b-tr v-for="(item, index) in tableData.list" :key="index">
                    <b-th
                        class="text-center text-nowrap px-0"
                        style="width:100px;position: sticky;left:0px;z-index:2;"
                        :style="`background-color:${theme === 'dark' ? '#343d55' : '#f3f2f7'};`"
                    >
                        <p class="mb-0 px-2">
                            {{ item.date.substring(5,10) }}
                        </p>
                    </b-th>
                    <b-td
                        class="text-right" v-for="(product, productIdx) in tableData.allProducts" :key="productIdx"
                        style="min-width:150px;"
                        :style="{ 'padding-right': tableData.allProducts.length < 4 ? '30px' : '' }"
                    >
                        <a
                            v-if="typeof item.products[product] === 'number'"
                            @click="emitDetailLayerWithProduct(item.date, product)"
                            class="data-with-event"
                        >
                            {{ $_getDollar(item.products[product]) }}
                        </a>
                        <span
                            v-else
                        >
                            -
                        </span>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
</template>
<script>
import { computed, toRefs, inject } from '@vue/composition-api'
export default {
    props: ['data'],
    setup (props, context) {
        const theme = inject('theme')
        const { data } = toRefs(props)
        const tableData = computed(() => {
            const isProductCode = {}
            const allProducts = []
            const list = []
            data.value.forEach((item, index) => {
                const products = {}
                if (item.cost === 0) return
                item.products.forEach(subItem => {
                    products[subItem.productCode] = subItem.cost
                    if (isProductCode[subItem.productCode]) return
                    isProductCode[subItem.productCode] = true
                    allProducts.push(subItem.productCode)
                })
                list.push({
                    date: item.date,
                    products
                })
            })
            return {
                list,
                isProductCode,
                allProducts
            }
        })
        const emitDetailLayerWithProduct = (date, productCode) => {
            context.emit('modal:showDetail', { date, productCode })
        }

        return {
            tableData,
            emitDetailLayerWithProduct,
            theme
        }
    }
}
</script>
